import styled from "styled-components";

const ExtSelect = styled.div`
  display: ${(props) => (props.display ? props.display : "block")};
  position: relative;
  border-radius: ${(props) => props.theme.PrimaryRadius};
  ${(props) => props.theme.Elevate.mid};
  margin: 10px 0;
  background: #fff;
  height: 70px;
  border: none;
  width: 100%;

  & .kDTYwo > div .flexi__control {
    border: none;
    padding: 0 5px 0 15px;
  }

  & .react-date-picker {
    border: none;
    height: 70px;
    padding: 0 12px;
  }
`;

export default ExtSelect;
